<template>
  <component :is="tag" :class="$style.stackItem" :style="style">
    <slot />
  </component>
</template>

<script>
export default {
  name: 'StackItem',
  props: {
    tag: {
      type: String,
      default: 'li',
      validator: (value) => ['li', 'div'].includes(value),
    },
    space: {
      type: Number,
      default: 3,
      validator: (value) => Number.isInteger((value * 10) % 5), // 0.5刻みまで許容
    },
  },
  computed: {
    style() {
      return {
        '--space': `calc(var(--spacer-base) * ${this.space})`,
      };
    },
  },
};
</script>

<style lang="scss" module>
.stackItem {
  & + & {
    margin-top: var(--space);
  }
}
</style>
